import { FunctionComponent, forwardRef } from "react"
import { Button as BButton } from "react-bootstrap"
import { FaArrowLeft, FaArrowRight, FaCircleNotch, FaCopy, FaFacebookF, FaGoogle, FaInfoCircle, FaLink, FaPlus, FaSearch, FaShare, FaSpinner, FaTrash } from "react-icons/fa"
import { BiShareAlt } from "react-icons/bi"
import { Color } from "../../env"
import { MdClose } from "react-icons/md"

export enum variant {
    Primary,
    Secondary,
    Danger,
    Success,
    NoFill,
}

export interface ButtonProps {
    id?: string
    name?: string
    buttonvariant: variant
    icon?: icon
    style?: any
    disabled?: boolean
    buttonShape?: shape
    borderRadius?: number
    color?: string
    onClick: () => void
}

export enum shape {
    Circle
}

export enum icon {
    Trash,
    Plus,
    RightArrow,
    LeftArrow,
    Copy,
    Search,
    Link,
    Share,
    Close,
    Facebook,
    Google,
    Spinner,
    Info
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {

    const getColor = () => {
        if (props.color) {
            return props.color
        }

        switch (props.buttonvariant) {
            case variant.Secondary:
                return Color.Grey
            case variant.Danger:
                return Color.Red
            case variant.Success:
                return "#198753"
            case variant.NoFill:
                return "transparent"
            default:
                return Color.Primary
        }
    }

    let borderRadius = props.borderRadius || 0
    if (props.buttonShape === shape.Circle) {
        borderRadius = 100
    }

    return (
        <BButton
            {...props}
            ref={ref}
            id={props.id}
            disabled={props.disabled}
            style={{ background: getColor(), borderRadius: borderRadius, borderColor: getColor(), ...props.style }}
            onClick={() => props.onClick()}
        >
            {(props.name && props.icon !== undefined) && <>{props.name} <Icon icon={props.icon!} /></>}
            {(props.name && props.icon === undefined) && <>{props.name}</>}
            {(!props.name && props.icon !== undefined) && <><Icon icon={props.icon!} /></>}
        </BButton>
    )
})

export interface IconProps {
    icon: icon
    size?: number
    color?: string
}

export const Icon: FunctionComponent<IconProps> = (props) => {
    switch (props.icon) {
        case icon.Trash:
            return <FaTrash color={props.color} />
        case icon.Plus:
            return <FaPlus color={props.color} />
        case icon.LeftArrow:
            return <FaArrowLeft color={props.color} />
        case icon.RightArrow:
            return <FaArrowRight color={props.color} />
        case icon.Copy:
            return <FaCopy color={props.color} />
        case icon.Search:
            return <FaSearch color={props.color} />
        case icon.Link:
            return <FaLink color={props.color} />
        case icon.Share:
            return <BiShareAlt color={props.color} />
        case icon.Close:
            return <MdClose color={props.color} />
        case icon.Facebook:
            return <FaFacebookF color={props.color} size={props.size} />
        case icon.Google:
            return <FaGoogle color={props.color} size={props.size} />
        case icon.Spinner:
            return (
                <div style={{ display: "inline-block" }}>
                    <style>
                        {`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}
                    </style>
                    <FaSpinner
                        color={props.color}
                        size={props.size}
                        style={{ animation: "spin 1.5s linear infinite" }}
                    />
                </div>
            )
        case icon.Info:
            return <FaInfoCircle color={props.color} size={props.size} />
        default:
            return <div></div>
    }
}
